<div class="container">

  <!-- Comparison Section-->
  <div class=" offset-1 col-10">
    <div class=" content">
      <div class=" row">
        <div class="col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-5 text-left">
                  <h5 class=" card-category">Strategy Builder</h5>
                  <h2 class=" card-title"><i class="fas fa-stream fa-lg"></i>&nbsp;&nbsp;&nbsp; Target Strategies Comparison</h2>
                </div>
                <div class=" col-7">
                  <div class=" btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='select'}"
                          (click)="selectedPage='select'">Selection</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='styleBox'}"
                          (click)="selectedPage='styleBox'">Style Box</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='analytics'}"
                          (click)="selectedPage='analytics';selectedAnalyticsTab='exposure'">Analytics</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='ratings'}"
                          (click)="selectedPage='ratings'">Robustness</label>
                  </div>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngIf="selectedPage=='select'">

                <p class="card-text text-center">These strategies represent different patterns of diversification</p>

                <!-- Selection table -->
                <div class="row"><div class="offset-1 col-10">
                  <table mdbTable small="true" *ngIf="strategyTypeList && strategyParameters && defaultStrategy1 && defaultStrategy2 && defaultStrategy3">
                    <thead>
                    <tr>
                      <th></th>
                      <ng-container *ngFor="let strategyType of strategyTypeList">
                        <th *ngIf="strategyType.enabled" scope="col">{{ strategyType.name }}</th>
                      </ng-container>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th style="color: grey">Selection</th>
                      <ng-container *ngFor="let strategyType of strategyTypeList">
                        <td *ngIf="strategyType.enabled">
                          <mat-checkbox [checked]="strategyParameters.strategy_type==strategyType"
                                        (change)="onStrategySelection(strategyType)"></mat-checkbox>
                        </td>
                      </ng-container>
                    </tr>
                    </tbody>
                  </table>
                </div></div>
                <!-- Selection table -->

                <p class="text-center mt-3">But if you wish, you can freely improve your target strategy</p>

                <!-- Selected table -->
                <div class="row"><div class="offset-1 col-10">
                  <table mdbTable small="true" *ngIf="doCustomize && strategyTypeList">
                    <thead>
                    <tr>
                      <th></th>
                      <ng-container *ngFor="let strategyType of strategyTypeList">
                        <th *ngIf="strategyType.enabled" scope="col">{{ strategyType.name }}</th>
                      </ng-container>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Risk Contributions</th>
                      <ng-container *ngFor="let strategyType of strategyTypeList">
                        <td *ngIf="strategyType.enabled">
                          <mat-checkbox *ngIf="strategyType.customizable_risk_contributions" disabled=true checked=true></mat-checkbox>
                        </td>
                      </ng-container>
                    </tr>
                    <tr>
                      <th scope="row">Factor Exposure</th>
                      <ng-container *ngFor="let strategyType of strategyTypeList">
                        <td *ngIf="strategyType.enabled">
                          <mat-checkbox *ngIf="strategyType.customizable_exposure" disabled=true checked=true></mat-checkbox>
                        </td>
                      </ng-container>
                    </tr>
                    <tr>
                      <th scope="row">Volatility Target</th>
                      <ng-container *ngFor="let strategyType of strategyTypeList">
                        <td *ngIf="strategyType.enabled">
                          <mat-checkbox *ngIf="strategyType.customizable_volatility" disabled=true checked=true></mat-checkbox>
                        </td>
                      </ng-container>
                    </tr>
                    </tbody>
                  </table>
                </div></div>
                <!-- Selected table -->
              </div>

              <div *ngIf="selectedPage=='styleBox'">
                <!-- Style Box chart -->
                <app-style-box *ngIf="styleBoxData"
                              [catNames]="['Weights','Risk']"
                              [catFields]="['factor_deconcentration','factor_diversification']"
                              [series]="[
                                      {label: 'default1', name: defaultStrategy1.name, values: defaultStrategy1 ? styleBoxData.default1 : undefined},
                                      {label: 'default2', name: defaultStrategy2.name, values: defaultStrategy2 ? styleBoxData.default2 : undefined},
                                      {label: 'default3', name: defaultStrategy3.name, values: defaultStrategy3 ? styleBoxData.default3 : undefined}
                                    ]">
                </app-style-box>
                <!-- Style Box chart -->
              </div>

              <div *ngIf="selectedPage=='analytics'">
                <!--Analytics Section-->
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onAnalyticsTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab *ngIf="defaultStrategy1 || defaultStrategy2 || defaultStrategy3" label="Exposure"></mat-tab>
                  <mat-tab *ngIf="defaultStrategy1 || defaultStrategy2 || defaultStrategy3" label="Absolute"></mat-tab>
                  <mat-tab *ngIf="defaultStrategy1 || defaultStrategy2 || defaultStrategy3" label="Relative"></mat-tab>
                  <mat-tab *ngIf="defaultStrategy2 || defaultStrategy2 || defaultStrategy3" label="Rating"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Exposure table -->
                <table *ngIf="selectedAnalyticsTab=='exposure' && (defaultStrategy1 || defaultStrategy2 || defaultStrategy3)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="40%"></th>
                    <th *ngIf="defaultStrategy1" scope="col">{{ defaultStrategy1.name }}</th>
                    <th *ngIf="defaultStrategy2" scope="col">{{ defaultStrategy2.name }}</th>
                    <th *ngIf="defaultStrategy3" scope="col">{{ defaultStrategy3.name }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Size</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Value</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Momentum</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Volatility</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">High Yield</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Quality</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Factor Intensity</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Exposure table -->

                <!-- Absolute table -->
                <table *ngIf="selectedAnalyticsTab=='absolute' && (defaultStrategy1 || defaultStrategy2 || defaultStrategy3)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="40%"></th>
                    <th *ngIf="defaultStrategy1" scope="col">{{ defaultStrategy1.name }}</th>
                    <th *ngIf="defaultStrategy2" scope="col">{{ defaultStrategy2.name }}</th>
                    <th *ngIf="defaultStrategy3" scope="col">{{ defaultStrategy3.name }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Returns</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Volatility</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Sharpe ratio</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Max Drawdown</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Absolute table -->

                <!-- Relative table -->
                <table *ngIf="selectedAnalyticsTab=='relative' && (defaultStrategy1 || defaultStrategy2 || defaultStrategy3)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="40%"></th>
                    <th *ngIf="defaultStrategy1" scope="col">{{ defaultStrategy1.name }}</th>
                    <th *ngIf="defaultStrategy2" scope="col">{{ defaultStrategy2.name }}</th>
                    <th *ngIf="defaultStrategy3" scope="col">{{ defaultStrategy3.name }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Excess Returns</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tracking Error</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Information ratio</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Max Relative Drawdown</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Relative table -->

                <!-- Diversification table -->
                <table *ngIf="selectedAnalyticsTab=='rating'" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="40%"></th>
                    <th *ngIf="defaultStrategy1" scope="col">{{ defaultStrategy1.name }}</th>
                    <th *ngIf="defaultStrategy2" scope="col">{{ defaultStrategy2.name }}</th>
                    <th *ngIf="defaultStrategy3" scope="col">{{ defaultStrategy3.name }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Factor Intensity</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Deconcentration</th>
                    <td *ngIf="defaultStrategy1 && defaultStrategy1.factorAnalysis">
                      <app-rating-span [rating]="defaultStrategy1.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy2 && defaultStrategy2.factorAnalysis">
                      <app-rating-span [rating]="defaultStrategy2.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy3 && defaultStrategy3.factorAnalysis">
                      <app-rating-span [rating]="defaultStrategy3.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Effective Number of Factors</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Diversification</th>
                    <td *ngIf="defaultStrategy1 && defaultStrategy1.factorAnalysis">
                      <app-rating-span [rating]="defaultStrategy1.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy2 && defaultStrategy2.factorAnalysis">
                      <app-rating-span [rating]="defaultStrategy2.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy3 && defaultStrategy3.factorAnalysis">
                      <app-rating-span [rating]="defaultStrategy3.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Effective Number of Risks</th>
                    <td *ngIf="defaultStrategy1">{{ defaultStrategy1.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy2">{{ defaultStrategy2.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                    <td *ngIf="defaultStrategy3">{{ defaultStrategy3.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Diversification table -->

                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                  </em>
                </div>
                <!--Analytics Section-->
              </div>

              <div *ngIf="selectedPage=='ratings'">
                <!-- Robustness table -->
                <table *ngIf="defaultStrategy1" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="40%"></th>
                    <th *ngIf="defaultStrategy1" scope="col">{{ defaultStrategy1.name }}</th>
                    <th *ngIf="defaultStrategy2" scope="col">{{ defaultStrategy2.name }}</th>
                    <th *ngIf="defaultStrategy3" scope="col">{{ defaultStrategy3.name }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Performance</th>
                    <td *ngIf="defaultStrategy1 && defaultStrategy1.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy1.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy2 && defaultStrategy2.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy2.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy3 && defaultStrategy3.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy3.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Risk</th>
                    <td *ngIf="defaultStrategy1 && defaultStrategy1.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy1.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy2 && defaultStrategy2.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy2.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy3 && defaultStrategy3.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy3.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Outperformance</th>
                    <td *ngIf="defaultStrategy1 && defaultStrategy1.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy1.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy2 && defaultStrategy2.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy2.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy3 && defaultStrategy3.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy3.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Global Rating</th>
                    <td *ngIf="defaultStrategy1 && defaultStrategy1.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy1.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy2 && defaultStrategy2.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy2.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                    </td>
                    <td *ngIf="defaultStrategy3 && defaultStrategy3.robustnessAnalysis">
                      <app-rating-span [rating]="defaultStrategy3.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!-- Robustness table -->

                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                  </em>
                </div>
              </div>
            </div>

            <div class=" card-footer">
              <!-- Exposure -->
              <div *ngIf="selectedPage=='select'" class="row">
                <div class="col-6 text-center">
                  <app-button (click)="onChangeBlock('customize')" [disabled]="disableActions">Go to Customize</app-button>
                </div>
                <div class="col-6 text-center">
                  <app-button (click)="onChangeBlock('implement')" [disabled]="disableActions">Go to Implement</app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Comparison Section-->
  </div>

</div>


